/**
 * saveFriends.js
 * Written by: Alex Kasemir
 */

import request from 'axios';
import { API_BASE, fbEnsureInit } from '../../../../utils';

export const SAVE_FRIENDS_START = `SAVE_FRIENDS_START`;
export const SAVE_FRIENDS_SUCCESS = `SAVE_FRIENDS_SUCCESS`;
export const SAVE_FRIENDS_FAILURE = `SAVE_FRIENDS_FAILURE`;

export const saveFriendsStart = () => ({
  type: SAVE_FRIENDS_START,
});

export const saveFriendsSuccess = (data) => ({
  type: SAVE_FRIENDS_SUCCESS,
  data,
});

export const saveFriendsFailure = (error) => ({
  type: SAVE_FRIENDS_FAILURE,
  error,
});

const getFriends = (after = ``) => {
  let data = [];

  return new Promise((resolve) => {
    const url = `/me/friends${after ? `?after=${after}` : ``}`;
    FB.api(url, (response) => {
      data = [...data, ...response.data];
      if (response.paging && response.paging.next) {
        getFriends(response.paging.after);
      } else {
        resolve(data);
      }
    });
  });
};

/**
 * Description of the saveFriends action
 */
export const saveFriends = () => {
  return (dispatch, getState) => {
    dispatch(saveFriendsStart());

    const authHeader = getState().user.JWT ? `JWT ${getState().user.JWT}` : ``;
    return new Promise((resolve) => {
      fbEnsureInit(() => {
        FB.getLoginStatus((resp) => {
          if (resp.status === `connected`) {
            getFriends()
              .then((friends) => {
                request.post(`${API_BASE}/friends/`, { friends }, {
                  headers: {
                    'Content-Type': `application/json`,
                    Authorization: authHeader,
                  },
                })
                  .then((response) => {
                    dispatch(saveFriendsSuccess(response.data));
                    resolve();
                  })
                  .catch((err) => {
                    dispatch(saveFriendsFailure(err));
                    resolve();
                  });
              });
          } else {
            resolve();
          }
        });
      });
    });
  };
};

export default saveFriends;

